import {
  useCurrentUser,
  useUpdateSchedule,
  ScheduleSchema,
} from "@/lib/api/user";
import { getUserTimezoneWithDefault } from "@/lib/utils/timezone";
import { ScheduleSettingsUI } from "./schedule-settings";

const DAYS_OF_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const NYC_DEFAULT_DAY_SETTINGS: Record<
  string,
  { isOnline: boolean; startTime: string; endTime: string }
> = {
  Monday: { isOnline: true, startTime: "17:00", endTime: "22:00" },
  Tuesday: { isOnline: true, startTime: "17:00", endTime: "22:00" },
  Wednesday: { isOnline: true, startTime: "17:00", endTime: "22:00" },
  Thursday: { isOnline: true, startTime: "17:00", endTime: "22:00" },
  Friday: { isOnline: true, startTime: "17:00", endTime: "19:00" },
  Saturday: { isOnline: false, startTime: "17:00", endTime: "19:00" },
  Sunday: { isOnline: false, startTime: "17:00", endTime: "19:00" },
};

const DEFAULT_SCHEDULE = DAYS_OF_WEEK.map((day) => {
  const config = NYC_DEFAULT_DAY_SETTINGS[day];
  return {
    day,
    isOnline: config?.isOnline ?? false,
    startTime: config?.startTime ?? "",
    endTime: config?.endTime ?? "",
  };
});

export function ScheduleSettings() {
  const { data: user } = useCurrentUser();
  const { mutateAsync: updateScheduleMutation, isPending } =
    useUpdateSchedule();

  const defaultValues: ScheduleSchema = {
    schedule: user?.metadata?.schedule || DEFAULT_SCHEDULE,
    timezone: getUserTimezoneWithDefault(user),
    autoDetectTimezone: user?.metadata?.auto_detect_timezone ?? true,
  };

  const handleSubmit = async (data: ScheduleSchema) => {
    await updateScheduleMutation(data);
  };

  return (
    <ScheduleSettingsUI
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      isPending={isPending}
    />
  );
}
